import { gql } from '@apollo/client'

export const FIND_SCHOOL_LIST_BY_PLATFORM = gql`
  query findSchoolListByPlatform($platformId: String!) {
    findSchoolListByPlatform(platformId: $platformId) {
      id
      schoolArray {
        key
        value
      }
    }
  }
`
